import { createApp } from 'vue'
import App from '@/App.vue'
import router from '@/router'
import store from '@/store'
import filters from '@/filters.js'
import 'nprogress/nprogress.css'
import VueMask from '@devindex/vue-mask'

import { GDialog, plugin as dialogPlugin } from 'gitart-vue-dialog'
import 'gitart-vue-dialog/dist/style.css'

import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'

const app = createApp(App)
app
  .use(router)
  .use(store)
  .use(dialogPlugin)
  .use(VueMask)
  .component('GDialog', GDialog)
  .component('v-select', vSelect)
  .mount('#app')

app.config.globalProperties.$filters = filters
